import PageContainer                      from '@/components/pageContainer/PageContainer';
import PageTitle                          from '@/components/pageTitle/PageTitle';
import PersonalInformationBox             from './components/PersonalInformationBox';
import PersonalInformationDeletionBox     from './components/PersonalInformationDeletionBox';
import UserDeletionRequestModel           from '@/models/services/fondations/UserDeletionRequestModel';
import authStore                          from '@/stores/authStore';
import useApiCollection                   from '@widesk-core/hooks/useApiCollection';
import useFetch                           from '@widesk-core/hooks/useFetch';
import { useTranslation }                 from 'react-i18next';
import React                              from 'react';
import Modal                              from '@/components/modal/Modal';
import { ModalData }                      from '@/components/modal/Modal';

export type DeletionAlert = {
	status: 'error' | 'info' | 'success',
	title: string,
}

const PersonalInformationPage = () => {
	const { t } = useTranslation();
	const userDeletionRequestCollection = useApiCollection(UserDeletionRequestModel);

	const [modalData, setModalData] = React.useState<ModalData | undefined>();
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	useFetch(async () => {
		await Promise.all([
			userDeletionRequestCollection.setFilter('user', authStore.currentUser.id).list(),
		]);

		await userDeletionRequestCollection.whenIsLoaded(m => m.userDeletionRequestStatus);

	}, true);

	return (
		<PageContainer>
			<Modal 
				model={modalData?.model}
				isDangerous={modalData?.isDangerous}
				isOpen={modalIsOpen}
				setIsOpen={setModalIsOpen}
				titleComponent={modalData?.titleComponent}
				bodyComponent={modalData?.bodyComponent}
				onConfirm={modalData?.onConfirm}
				onClose={modalData?.onClose}
				onSuccess={modalData?.onSuccess}
			/>
			<PageTitle>
				{t('pages.personalInformation.label')}
			</PageTitle>

			<PersonalInformationBox />

			<PersonalInformationDeletionBox 
				userDeletionRequestCollection={userDeletionRequestCollection} 
				setModalData={setModalData}
				setModalIsOpen={setModalIsOpen}
			/>
		</PageContainer>
	)
}

export default PersonalInformationPage;